import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import {
  customMaterialsQuery,
  getCustomMaterialsQueryData,
  setCustomMaterialsQueryData,
} from "#modules/materials/infra/customMaterials.query";
import { deleteMaterialApi } from "#modules/materials/infra/deleteMaterial.api";

export const useDeleteMaterial = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: deleteMaterialApi,
    onMutate: async (variables) => {
      await queryClient.cancelQueries({ queryKey: customMaterialsQuery().queryKey });
      const previous = getCustomMaterialsQueryData(queryClient);

      if (previous) {
        setCustomMaterialsQueryData(
          queryClient,
          previous.filter((material) => material.id !== variables.id),
        );
      }

      return { previous };
    },
    onError: (err: Error, _variables, context) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      if (context?.previous) {
        setCustomMaterialsQueryData(queryClient, context.previous);
      }
    },
    onSettled: () => {
      void queryClient.invalidateQueries(customMaterialsQuery());
    },
  });

  return { deleteMaterial: mutate, ...rest };
};
